export default class CSSOValuesProvider {
    getFlowDisplayName = () => {
        return 'NN CSSO flow';
    }

    getRedirectionDetails = () => {
        return {
            baseUrlForClient: '/c-auth-policy-search',
            state: { policyNumberEditable: true }
        };
    }

    isBrokerContext = () => {
        return false;
    }

    getTypefilterNameForReporterRelation = () => {
        return 'FrontEndSelectable';
    }

    saveAndResumeEnabled = () => {
        return true;
    }

    getAuthenticationChannel = () => {
        return 'B2C';
    };
}
